const API_BASE_URL = process.env.VUE_APP_API_URL;

export const apiUrl = {
  usuarios: {
    login: `${API_BASE_URL}usuarios/login/`,
    logout: `${API_BASE_URL}usuarios/logout/`,
    usuarioLogado: `${API_BASE_URL}usuarios/user/`,
    tokenRefresh: `${API_BASE_URL}usuarios/token/refresh/`,
    verificarToken: `${API_BASE_URL}usuarios/verificar-token/`,
    createList: `${API_BASE_URL}usuarios/list/`,
    retrieveUpdateDestroy: (id) => `${API_BASE_URL}usuarios/${id}/`,
    adminCreateList: `${API_BASE_URL}usuarios/admin/list/`,
    adminRetrieveUpdateDestroy: (id) => `${API_BASE_URL}usuarios/admin/${id}/`,
    perfilUpdate: (id) => `${API_BASE_URL}usuarios/perfil/${id}/`,
    reset: (id) => `${API_BASE_URL}usuarios/reset/${id}/`,
  },
  empresas: {
    createList: `${API_BASE_URL}empresas/list/`,
    retrieveUpdateDestroy: (id) => `${API_BASE_URL}empresas/${id}/`,
  },
  analises: {
    createList: `${API_BASE_URL}analises/list/`,
    retrieveUpdateDestroy: (id) => `${API_BASE_URL}analises/${id}/`,
    faseCreateList: `${API_BASE_URL}analises/fase/`,
    relatorio: `${API_BASE_URL}analises/relatorio/`,
  },
  auditoria: {
    list: `${API_BASE_URL}auditoria/list/`,
    contentTypeList: `${API_BASE_URL}auditoria/list/content_type`,
    retrieve: (id) => `${API_BASE_URL}auditoria/${id}/`,
  },
  clientes: {
    createList: `${API_BASE_URL}clientes/list/`,
    retrieveUpdateDestroy: (id) => `${API_BASE_URL}clientes/${id}/`,
    relatorio: `${API_BASE_URL}clientes/relatorio/`,
  },
  compras: {
    createList: `${API_BASE_URL}compras/list/`,
    retrieveUpdateDestroy: (id) => `${API_BASE_URL}compras/${id}/`,
    itensCreateList: `${API_BASE_URL}compras/itens/list/`,
    itensDestroy: (id) => `${API_BASE_URL}compras/itens/${id}/`,
    relatorio: `${API_BASE_URL}compras/relatorio/`,
  },
  construcoes: {
    createList: `${API_BASE_URL}construcoes/list/`,
    retrieveUpdateDestroy: (id) => `${API_BASE_URL}construcoes/${id}/`,
    etapaCreateList: (id) => `${API_BASE_URL}construcoes/etapa/list/${id}/`,
    etapaRetrieveUpdateDestroy: (id) => `${API_BASE_URL}construcoes/etapa/${id}/`,
    materialCreateList: `${API_BASE_URL}construcoes/material/list/`,
    materialDestroy: (id) => `${API_BASE_URL}construcoes/material/${id}/`,
    relatorio: `${API_BASE_URL}construcoes/relatorio/`,
  },
  corretores: {
    createList: `${API_BASE_URL}corretores/list/`,
    retrieveUpdateDestroy: (id) => `${API_BASE_URL}corretores/${id}/`,
    relatorio: `${API_BASE_URL}corretores/relatorio/`,
  },
  crm: {
    login: `${API_BASE_URL}crm/login/`,
    logout: `${API_BASE_URL}crm/logout/`,
    createList: `${API_BASE_URL}crm/list/`,
    garantias: `${API_BASE_URL}crm/garantias/`,
    retrieve: (id) => `${API_BASE_URL}crm/${id}/`,
    createListResposta: `${API_BASE_URL}crm/list/resposta/`,
  },
  documentos: {
    create: `${API_BASE_URL}documentos/create/`,
    list: (id) => `${API_BASE_URL}documentos/list/${id}/`,
    destroy: (id) => `${API_BASE_URL}documentos/${id}/`,
  },
  etapas: {
    createList: `${API_BASE_URL}etapas/list/`,
    retrieveUpdateDestroy: (id) => `${API_BASE_URL}etapas/${id}/`,
  },
  fornecedores: {
    createList: `${API_BASE_URL}fornecedores/list/`,
    retrieveUpdateDestroy: (id) => `${API_BASE_URL}fornecedores/${id}/`,
    relatorio: `${API_BASE_URL}fornecedores/relatorio/`,
  },
  imagens: {
    create: `${API_BASE_URL}imagens/create/`,
    list: (id) => `${API_BASE_URL}imagens/list/${id}/`,
    destroy: (id) => `${API_BASE_URL}imagens/${id}/`,
  },
  imoveis: {
    createList: `${API_BASE_URL}imoveis/list/`,
    retrieveUpdateDestroy: (id) => `${API_BASE_URL}imoveis/${id}/`,
  },
  materiais: {
    createList: `${API_BASE_URL}materiais/list/`,
    retrieveUpdateDestroy: (id) => `${API_BASE_URL}materiais/${id}/`,
  },
  modelos: {
    createList: `${API_BASE_URL}modelos/list/`,
    retrieveUpdateDestroy: (id) => `${API_BASE_URL}modelos/${id}/`,
    etapaCreateList: (id) => `${API_BASE_URL}modelos/etapa/list/${id}/`,
    etapaRetrieveUpdateDestroy: (id) => `${API_BASE_URL}modelos/etapa/${id}/`,
    materialCreateList: `${API_BASE_URL}modelos/material/list/`,
    materialDestroy: (id) => `${API_BASE_URL}modelos/material/${id}/`,
  },
  saidas: {
    createList: `${API_BASE_URL}saidas/list/`,
    retrieveUpdateDestroy: (id) => `${API_BASE_URL}saidas/${id}/`,
    itensCreateList: `${API_BASE_URL}saidas/itens/list/`,
    itensDestroy: (id) => `${API_BASE_URL}saidas/itens/${id}/`,
  },
  servicos: {
    createList: `${API_BASE_URL}servicos/list/`,
    retrieveUpdateDestroy: (id) => `${API_BASE_URL}servicos/${id}/`,
  },
};